import { Dictionary } from './dictionary';

export class Recognition {
    id: number;
    status: number;
    line: number;
    carparkNumber: number;
    direction: number;
    licensePlate: string;
    country: string;
    province: string;
    licensePlateType: string;
    recognitionTime: Date;
    manualInterventionAllowed: boolean;
    manualOpen: boolean;
    whiteList: boolean;
    grayList: boolean;
    ticketNumber: string;
    ticketType: number;
    ticketCreateTime: Date;
    entryTime: Date;
    exitTime: Date;
    recMsg: string;
    imageStoreMode: string;
    recognitionImagePath: string;
    carpark: Dictionary<number, string>;
    recognitionStatus: number;
    serialNo: string;
    recognitionSource: number;
}
